export default {
    webPushEndpointId: 'Travelata.UniversalWhitelabel',
    endpointId: 'Travelata.UniversalWhitelabel',
    pointOfContactSystemName: '',
    firebaseMessagingSenderId: '',
};